import { getHelperDownloadUrl } from '@/config/helperDownload';
import { useHelperDialogStore } from '@/state/helperDialogStore';
import { useHelperStartDialogStore } from '@/state/helperStartDialogStore';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@mui/material';

export function HelperRequiredDialog() {
  const open = useHelperDialogStore((state) => state.open);
  const close = useHelperDialogStore((state) => state.close);
  const showStartDialog = useHelperStartDialogStore((state) => state.show);
  const downloadUrl = getHelperDownloadUrl();

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Skyrover Helper required</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Upload and compile run on your computer through a small helper app. The website alone
          cannot flash your board.
        </Typography>

        <Box component="ol" sx={{ m: 0, pl: 2.5, color: 'text.secondary', fontSize: 14 }}>
          <li>Download and install Skyrover Helper on this Windows PC (includes Arduino CLI)</li>
          <li>Leave it running (you should see it listening on port 7421)</li>
          <li>Refresh this page — status bar should show <strong>Helper online</strong></li>
          <li>Open <strong>Board Manager</strong> and download the package for your board</li>
          <li>Connect your board and click Upload again</li>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          No separate Arduino IDE install is required. Board packages are chosen in Board Manager.
        </Typography>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          Already installed?{' '}
          <Link
            component="button"
            type="button"
            onClick={() => {
              close();
              showStartDialog();
            }}
            sx={{ verticalAlign: 'baseline' }}
          >
            Start Helper instead
          </Link>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={close}>Close</Button>
        <Button
          component="a"
          href={downloadUrl}
          download
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={close}
        >
          Download Helper
        </Button>
      </DialogActions>
      <Box sx={{ px: 3, pb: 2 }}>
        <Typography variant="caption" color="text.secondary">
          Direct link:{' '}
          <Link href={downloadUrl} target="_blank" rel="noopener noreferrer">
            {downloadUrl}
          </Link>
        </Typography>
      </Box>
    </Dialog>
  );
}
